import { map, tap } from 'rxjs/operators';
import { MilestoneDTO } from './../api/plyca-dtos-v2';
import { Component, AfterContentInit, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { generateRandomIdentifier, UIService } from '../ui.service';
import { FormConfig } from '../components/forms/form.objects';
import { BaseFormComponent, BaseFormHeaderInfo } from '../tasks/baseFormComponent/baseForm.component';
import { Observable, of } from 'rxjs';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { getSimpleIdentifierFromString } from '../api/plyca-dtos';
import { DATEPIPE_DATE_FORMAT, PRIMENG_DATE_FORMAT } from '../../services/language.service';
import { AppConfiguration } from '../conf/app.configuration';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';
import { Router } from '@angular/router';

export class CalendarEvenModel {
  dto: MilestoneDTO;
  ui: {
    calMode?: string,
    insertMode?: boolean,
    updateMode?: boolean,
    readonlyMode?: boolean,
    types?: any,
    alltypes?: any,
    taskdivision?: any,
    divisions?: any
    params?: any
  };
}

@Component({
  selector: 'calendar-event',
  templateUrl: '../tasks/baseFormComponent/baseForm.template.html',
  providers: [DialogService, UIService]
})
export class CalendarEventComponent
  extends BaseFormComponent<MilestoneDTO, CalendarEvenModel>
  implements AfterContentInit, OnDestroy, OnInit {
  public DATEPIPE_DATE_FORMAT = DATEPIPE_DATE_FORMAT;

  public translate: TranslateService;

  private calendarEv: MilestoneDTO;
  private readonly = false;
  private identifier: string;
  private milestoneType: any;
  private project: any;
  private division: any;
  calMode: string;
  updateMode = false;
  insertMode = false;




  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    public appConfig: AppConfiguration,
    private plycaErrorHandler: PlycaErrorHandler,
    public ref: DynamicDialogRef,
    private router: Router
  ) {
    super(elem);


    this.windowHash = generateRandomIdentifier();
    this.readonly = dialogConfig['readonly'] ? dialogConfig['readonly'] : false;

    // Si se abre un evento existente llega en el context
    let context = dialogConfig['context'];
    if (context) {
      if (context && context.identifier) {
        this.updateMode = true;
      } else {
        this.insertMode = true;
      }
      this.calendarEv = context;
      this.updateMode = !this.readonly;
      if (this.calendarEv) {
        this.milestoneType = this.calendarEv.typeMilestone;
      }

    } else {
      // Si no llegan los datos del evento es un evento nuevo
      this.calendarEv = new MilestoneDTO();
      this.insertMode = true;
    }


    if (dialogConfig['project']) {
      this.project = dialogConfig['project'];
    }
    this.division = 0;
    if (dialogConfig['division']) {
      this.division = dialogConfig['division'];
    }

    if (dialogConfig['typeMilestone']) {
      this.milestoneType.identifier = dialogConfig['typeMilestone'];
    }


    this.identifier = dialogConfig['id'];




    this.calMode = dialogConfig['calMode'];
    this.task = undefined;



  }


  // Metodos obligatorios
  dtoToModel(dto: MilestoneDTO): Observable<CalendarEvenModel> {
    let model = new CalendarEvenModel();
    model.dto = dto;
    model.ui = {};

    model.ui.calMode = this.calMode;
    model.ui.insertMode = false;
    model.ui.updateMode = false;
    model.ui.readonlyMode = false;
    model.ui.params = {};


    if (this.readonly == true) {
      // model.ui.params['VER'] = '1,4';
      // model.ui.params.MODIFICABLE = 0;
    } else {
      model.ui.params['VER'] = '1,4';
      model.ui.params['MODIFICABLE'] = 1;
    }
    if (this.project && this.project.identifier) {
      model.ui.params['EXCLUIR'] = '\'OTRU\'';


    }


    if (this.insertMode) {
      model.ui.insertMode = true;


      if (this.calMode === 'MU' && model.ui.insertMode) { // Se inicializa por que es un insert en MU
        model.dto.typeMilestone.identifier = 'OTRU';
        // model.dto.typeMilestone.description = 'xx';
      } else if (this.calMode === 'ME') { // Se inicializa por que es un insert en MU
        model.dto.typeMilestone = { description: ' ', identifier: ' ' };

      }

      if (this.project && this.project.identifier) {
        model.dto.project = this.project;
        //  model.ui.taskdivision = this.division;
        this.subscribe(this.plycaService.getDossierDivisions(this.project.identifier, 'expansionSet:minimal'),
          (result) => {
            model.ui.divisions = result.content;

            // TODO se quita para evitar que preseleccione un tipo de expediente que no esté permitido por configuración
            let div = this.division + '<>' + this.project.identifier;
            model.dto.division = model.ui.divisions.find(element => element.identifier === div);
            /*
                                  model.dto.division = {};
                                  model.dto.division.identifier = this.division + '<>' + model.dto.project.identifier;
                                  model.dto.division.name = 'División establecida:' + model.ui.taskdivision;*/
          });


      }


      // TIPO HITO
      if (this.milestoneType) { // si llega por parámetro
        model.dto.typeMilestone = this.milestoneType;
      } else if (this.project && this.project.identifier) {
        // model.dto.typeMilestone = {};

      }
      if (model.dto.typeMilestone && model.dto.typeMilestone.identifier && model.dto.typeMilestone.identifier.indexOf('<>') < 0) {
        model.dto.typeMilestone.identifier = model.dto.typeMilestone.identifier + '';
      }

    } else if (this.updateMode) {
      if (model.dto.typeMilestone && model.dto.typeMilestone.identifier && model.dto.typeMilestone.identifier.indexOf('<>') < 0) {
        model.dto.typeMilestone.identifier = model.dto.typeMilestone.identifier + '';
      }

      model.ui.updateMode = true;


    } else {// readonly show event
      if (model.dto.typeMilestone && model.dto.typeMilestone.identifier && model.dto.typeMilestone.identifier.indexOf('<>') < 0) {
        model.dto.typeMilestone.identifier = model.dto.typeMilestone.identifier + '';
      }

      model.ui.readonlyMode = true;

    }







    return of(model);


  }
  modelToDTO(model: CalendarEvenModel): MilestoneDTO {
    let dto = new MilestoneDTO();

    dto = model.dto;

    if (dto.typeMilestone && dto.typeMilestone.identifier && dto.typeMilestone.identifier.indexOf('<>') > 0) {
      let tmp = getSimpleIdentifierFromString(model.dto.typeMilestone.identifier);
      dto.typeMilestone.identifier = tmp;
    }


    // igual no hace falta por que no hay tablas
    dto = JSON.parse(
      JSON.stringify(dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return dto;
  }


  getTitle(model: MilestoneDTO): string {
    return model.identifier;
  }

  getHeaderInfo(): BaseFormHeaderInfo {

    return undefined;
  }

  getServiceURL(): string {
    return this.configuration.MILESTONES_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    return this.identifier;
  }
  getFormSettingURL(): string {
    return 'calendar/calendarEventInterfaceSettings.json';
  }

  initHeaderActions() {
    if (this.readonly == false) {
      this.subscribe(
        this.headerActionsService
          .addWindowAction(
            'General.save',
            'fas fa-lg fa-check',
            'btn-primary',
            true,
            this.windowHash
          )
        , (success) => {
          this.guardar();
        });
    } else {
      if (!this.project && this.model?.dto?.project) {
        this.subscribe(
          this.headerActionsService
            .addWindowAction(
              'General.expView',
              'fa fa-archive',
              'btn-primary',
              true,
              this.windowHash
            )
          , (success) => {
            this.ref.close();
            this.openDossier(this.model.dto.project);
          });
      }
    }
    this.subscribe(
      this.headerActionsService.addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      (success) => {
        this.ref.close();
      }
    );
  }

  openDossier(dossier) {
    this.router.navigate(['/dossierInfo/' + dossier.identifier]);
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;

    formConfig.readonly = this.readonly;

    formConfig.windowHash = this.windowHash;

    formConfig.functions.push({
      identifier: 'checkDivision',
      fn: this.checkDivision
    });

    formConfig.functions.push({
      identifier: 'mapResult',
      fn: this.mapResult
    });


    return of(formConfig);
  }

  checkDivision(model: any) {

    let div = model.ui.taskdivision + '<>' + model.dto.project.identifier;
    if (model.ui.divisions) {
      model.dto.division = model.ui?.divisions.find(element => element.identifier === div);
    }


  }

  guardar() {
    this.subscribe(this.save(),

      (newEvent: MilestoneDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess(
          this.translate.instant('Calendar.success'),
          this.translate.instant('General.info'),
          'success'
        );
        this.ref.close(newEvent);
      }


    );




  }

  modalError(error) {
    this.ref.close();
    this.plycaErrorHandler.showServerError(error);

  }
  ngOnDestroy() {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }


  mapResult(model: any, result: any) {
    result['properties'] = {};
    result['identifier'] = result.content.identifier.value;
    result['description'] = result.content.description.value;
    result.properties['TIPO_DIVISION'] = result.content.TIPO_DIVISION.value;
    result.properties['PERMITE_DIVISION'] = result.content.PERMITE_DIVISION.value;

    result.content = undefined;

  }
}
